<template>
    <div class="portlet light">
        <div class="ss-titre">
            <span class="font-red-sunglo uppercase bold">L'ENCADRANT</span>
        </div>
        <div class="portlet-body">
            <div class="form-group">
                <div>
                    <!-- -------------------------------------Select encadrant --------------------------------------- -->
                    <div class="row">
                        <div class="col-md-4">
                            <label>Choisissez le Professionnel(adhérents)*</label>

                            <select name="user_reinforcements" v-model="enc" class="form-control">
                                <option v-for="enc in encadrant" :value="enc">{{ enc.name }} {{ enc.lastName || enc.lastname }}</option>
                            </select>
                        </div>
                        <div class="col-md-4 valign">
                            <label>Honoraires du pro pour l'activité (en €)*</label>
                            <input type="number" name="part" ref="input" class="form-control" v-model.number="part" />
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-md-1 text-center valign">
                            <a class="btn btn-success billingSuccess" @click.prevent="addEncadrant">Valider</a>
                        </div>
                    </div>
                    <!-- ------------------------------------------ end select encadrant------------------------------------- -->

                    <div id="errors_valid" v-show="errors !== false" style="color: red">
                      Veuillez sélectionner un professionnel ou vérifier que vous avez ajouté une activité dans la rubrique activité plus haut.
                    </div>
                    <!-- ----------------------table---------------- -->
                    <table v-if="this.value.length > 0 || this.renfortsValue.length > 0" class="table table-striped">
                        <thead>
                            <tr>
                                <th>Nom du pro</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                          <!-- -----------------------salarie------------------------------- -->
                            <tr v-for="enc in value">
                                <td>{{ enc.name }}</td>
                                <td>{{ enc.part }} €</td>
                                <input type="hidden" :value="enc.id" name="guidessup[]" id="guidesSup"/>
                                <input type="hidden" :value="enc.part" name="parts[]" />
                                <td>
                                    <a href="javascript:void(0)" class="btn btn-danger pull-right" @click="deleteUser(enc)"><i class="fa fa-trash"></i></a>
                                    <a href="javascript:void(0)" class="btn btn-primary pull-right" @click="updateUser(enc)"><i class="fas fa-pencil-alt"></i></a>
                                </td>
                            </tr>
                            <!-- -----------------------renfort------------------------------- -->
                            <tr v-for="renfort in renfortsValue">
                                <td>{{ renfort.name }}</td>
                                <td>{{ renfort.part }} €</td>
                                <input type="hidden" :value="renfort.id" name="renfortssup[]" id="renfortsSup"/>
                                <input type="hidden" :value="renfort.part" name="renfortsparts[]" />
                                <td>
                                    <a href="javascript:void(0)" class="btn btn-danger pull-right" @click="deleteRenfort(renfort)"><i class="fa fa-trash"></i></a>
                                    <a href="javascript:void(0)" class="btn btn-primary pull-right" @click="updateRenfort(renfort)"><i class="fas fa-pencil-alt"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "selectBillingEncadrantEcole",
  props: [
    'officeUsers','usersReinforcement', 'officeRenforts',
    'renfortsReinforcement', 'isencadrantsalarie', 'officeencadrant','hasbilling'
  ],
  data () {
    return {
      users: Object.assign([], this.officeUsers),
      renforts: Object.assign([], this.officeRenforts),
      value: Object.assign([], this.usersReinforcement),
      renfortsValue: Object.assign([], this.renfortsReinforcement),
      user: '',
      enc: '',
      renfort: '',
      part: '',
      errors : false,
      /* 'encadrant': 'salarie',*/
      encadrant: Object.assign([], _.sortBy(this.officeencadrant,function (i) {
        let prior = typeof i.email_hash === 'undefined' ? i.priority : i.pivot.priority;
        return 4 - prior + "_" + i.fullName.toLowerCase();
      })),
    }
  },
  computed: {
    price() {
      let price = 0
      for (let i = this.value.length - 1; i >= 0; i--) {
        price += this.value[i].part
      }
      this.$parent.$emit('update:totalDispatchedPrice', {
        'type' : 'user',
        'quantity' : price
      })
      return price
    }
  },
  methods: {
    addEncadrant(){
      if (this.enc !== '' && typeof this.enc.email_hash === 'undefined') {
        this.addRenfort()
      } else {
        this.addUser()
      }
    },
    addUser() {
      if (this.enc !== '') {
        this.enc['part'] = this.part
        this.value.push(this.enc)
        this.encadrant.splice(this.encadrant.indexOf(this.enc), 1)
        this.part = ''
        this.enc = ''
        this.errors = false

      } else {
        this.errors = true
      }
    },

    addRenfort() {
      if (this.enc !== '') {
        this.enc['part'] = this.part
        this.renfortsValue.push(this.enc)
        this.encadrant.splice(this.encadrant.indexOf(this.enc), 1)
        this.part = ''
        this.enc = ''
        this.errors = false
      } else {
        this.errors = true
      }
    },
    deleteUser(user) {
      this.encadrant.push(user)
      this.value.splice(this.value.indexOf(user), 1)
    },
    deleteRenfort(renfort) {
      this.encadrant.push(renfort)
      this.renfortsValue.splice(this.renfortsValue.indexOf(renfort), 1)
    },
    updateUser(user) {
      this.encadrant.push(user)
      this.enc = user
      this.part = user.part
      this.value.splice(this.value.indexOf(user), 1)
      this.$refs.input.focus()
    },
    updateRenfort(renfort) {
      this.encadrant.push(renfort)
      this.enc = renfort
      this.part = renfort.part
      this.renfortsValue.splice(this.renfortsValue.indexOf(renfort), 1)
      this.$refs.input.focus()
    }
  },
  mounted () {
    this.$parent.$on('update:totalDispatchedPrice', (e) => {
      if (e.fees) this.part = e.fees
    })
    this.users = this.users.concat(this.renforts)
    if(this.hasbilling){
      if(this.value.length>0){
        this.updateUser(this.value[0])
      }else if(this.renfortsValue.length>0){
        this.updateRenfort(this.renfortsValue[0])
      }
    }
  }
}
</script>

<style lang="css" scoped>
    .valign{
        justify-content: center;
        align-items: center;
    }
</style>

